import React, {Component} from 'react';
import PropTypes from 'prop-types';

class ModalToggler extends Component {
    render() {
        return <a   role="button"
                    data-title={this.props.title}
                    data-printable={this.props.printable}
                    data-content={this.props.content}
                    data-url={this.props.url}
                    onClick={this._onClickHandler.bind(this)}>{
                        this.props.children
                    }</a>;
    }

    _onClickHandler(e) {
        e.preventDefault();
        window.$(this.props.target).modal('show',e.currentTarget);
    }
}

ModalToggler.defaultProps = {
    target: "#modal-window",
    url: "",
    content: "",
    printable: false
}

ModalToggler.propTypes = {
    content: PropTypes.string.isRequired,
    url: PropTypes.string,
    target: PropTypes.string,
    title: PropTypes.string,
    printable: PropTypes.bool
}

export default ModalToggler;